import React from 'react';
import { motion } from 'framer-motion';

export const RadioField = ({ 
  id, 
  label, 
  value, 
  onChange, 
  options = [], 
  required = false,
  error = null,
  helpText = null
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mb-6"
    >
      <label className="block text-sm font-semibold text-gray-200 mb-3">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      
      {helpText && (
        <p className="text-sm text-gray-400 mb-3">{helpText}</p>
      )}
      
      <div className="space-y-3">
        {options.map((option, index) => {
          const optionValue = typeof option === 'object' ? option.value : option;
          const optionLabel = typeof option === 'object' ? option.label : option;
          const radioId = `${id}_${index}`;
          // Compare with index (stored value) but display optionLabel
          const isSelected = String(value) === String(index);
          
          // Debug logging for first option
          if (index === 0) {
            console.log(`RadioField ${id} - First option:`, {
              value,
              index,
              isSelected,
              valueType: typeof value,
              comparison: `"${String(value)}" === "${String(index)}"`
            });
          }
          
          return (
            <motion.div
              key={index}
              whileHover={{ scale: 1.01 }}
              className={`flex items-start p-4 rounded-lg border ${
                isSelected
                  ? 'border-teal-500 bg-teal-500/10'
                  : 'border-gray-700 bg-gray-800/50'
              } cursor-pointer transition-all`}
              onClick={() => {
                console.log(`RadioField ${id} clicked - index:`, index, 'calling onChange with:', index);
                onChange(index);
              }}
            >
              <input
                type="radio"
                id={radioId}
                name={id}
                value={index}
                checked={isSelected}
                onChange={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
                readOnly
                required={required && index === 0}
                className="mt-1 h-4 w-4 text-teal-500 border-gray-600 focus:ring-teal-500 focus:ring-offset-gray-900 cursor-pointer pointer-events-none"
              />
              <label
                htmlFor={radioId}
                className="ml-3 text-sm text-gray-200 cursor-pointer flex-1 select-none"
              >
                {optionLabel}
              </label>
            </motion.div>
          );
        })}
      </div>
      
      {error && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-red-400 text-sm mt-2"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
};

